var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 29.054 16.729 12.69 4.671-3.544a1 1 0 0 1 1.208 0l4.667 3.54 16.725-12.686v-19.054h-44zm22-14.054a9.01 9.01 0 0 1 9 9v2a2.994 2.994 0 0 1 -5.534 1.59 4.99 4.99 0 1 1 1.534-3.59v2a1 1 0 0 0 2 0v-2a7 7 0 1 0 -7 7h3a1 1 0 0 1 0 2h-3a9 9 0 0 1 0-18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.655 25 3.345 2.537v-5.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 58.986 21.074-15.987-21.074-15.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 27.537 3.345-2.537-3.345-2.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 27.014-21.074 15.985 21.074 15.987z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 40.255-26.027 19.745h52.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.063 8h9.874l-4.937-3.745z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.02adacec2df6034ee01af32fc23aaf4c.svg";
export { ForwardRef as ReactComponent };